




































































import { Component, Vue } from "vue-property-decorator";
import AuthApi from "@/services/AuthApi";
import { SetPasswordBody } from "@/api/lab-base-api-client";
import CTooltip from "@/components/CTooltip.vue";
import TooltipModule from "@/store/tooltip";
import logger from "@/lib/log/logger";

@Component({
  components: {
    CTooltip,
  },
})
export default class ResetPassForm extends Vue {
  // 入力フォーム初期値
  private form: SetPasswordBody = {
    password: "",
    confirmPassword: "",
  };

  // エラーモーダル表示
  private get isTooltipShow() {
    return TooltipModule.isShow;
  }

  // 「送信」clickで実行
  private async submit() {
    // queryからtokenを取得
    const { token } = this.$route.query;
    // tokenをセット
    const authRes = AuthApi.createInstance(token as string);
    // パスワードリセット
    try {
      if (this.$route.name === "MResetPassSet") {
        await authRes.setAdminPassword(this.form);
        this.$router.push({ name: "MResetPassComp" });
      } else if (this.$route.name === "UResetPassSet") {
        await authRes.setUserPassword(this.form);
        this.$router.push({ name: "UResetPassComp" });
      } else {
        await authRes.setOrganizationAdminPassword(this.form);
        this.$router.push({ name: "OResetPassComp" });
      }
    } catch (err) {
      if (err instanceof Error) {
        logger.frontError(`${err.name}: ${err.message}`);
        console.log(err);
      }
    }
  }
}
